/**
 * 分享工具类
 * 将逐步替换QQShareUtil
 * 相关文档：
 * https://docs.google.com/spreadsheets/d/1riXppy5EDJhpyCiol0bXfmMW140UNokCrqt7xIvXB0Y
 * https://docs.google.com/spreadsheets/d/1lLFXdeD-EpYq7weZnRB0yh2YwpxRjhlq/edit#gid=1858052468
 */
let ShareUtil = {}

const defaultShareScene = ShareScene.Session;

const _defaultShareJudgeTime = 2800
let _shareJudgeTimes = null;
let _shareGroups = null;

// 旧分享打点兼容，用于处理点击分享+分享成功打点
// 迭代完成后可删除
if (OLD_SHAREDC_AVAILABLE) {
    (function() {
        let _oldShareSuccessMap = {
            "timeModeAskHelp": ["timeMode", "click_gethelp_btn", "click_gethelp_btn_success"],
            "timeModeShare": ["timeMode", "click_share", "click_share_success"],
            "timeModeShowOff": ["timeMode", "click_share_btn", "click_share_btn_success"],
            "CoinMatchAskHelp": ["battleForGold", "click_invFriends_btn", "click_invFriends_btn_success"],
            "CoinMatchFailedAskHelp": ["battleForGold", "click_askforhelp", "click_askforhelp_success"],
            "CoinMatchShowOff": ["battleForGold", "click_share_btn", "click_share_btn_success"],
            "GoldMatchAskforhelp": ["goldMode", "click_askforhelp", "click_askforhelp_success"],
            "GoldMatchAskHelp": ["goldMode", "click_gethelp_btn", "click_getHelp_btn_success"],
            "GoldMatchShowOff": ["goldMode", "click_share_btn", "click_share_btn_success"],
            "group_rank": ["rank", null, "rank_showoff_success"],
            "rank_invite": ["rank", null, "addfriend_success"],
            "friend_pvp": ["PVP", null, "Invite_success"],
            "pvp_new_showoff": ["PVP", "click_share_btn", "share_success"],
            "interactive_invite": ["interactive", "click_interactive_share", "card_send_success"],
            "mark": ["Mark", "click_share_btn", "click_share_btn_success"],
            "treasure_box": ["redbag", "click_share", "click_share_success"],
            "newchest_gacha": ["newchest", "share_gacha_click", "share_gacha_success"],
            "newchest_reset": ["newchest", "share_reset_click", "share_reset_success"],
            "island_skip": ["island", "islanspdup_share", "islandspdup_success"],
            "island_unlock": ["island", "islandunlock_share", "islandunlock_share_success"],
            "island_upgrade": ["island", "upgrade", "upgrade_success"],
            "invite_pack": ["invitepack", null, "click_invitepack_btn_success"],
            "level_tip":["levelTip", "showoff_share", "showoff_share_success"],
            "passlevel_challenge": ["share", null, "level_showoff_share_success"],
            "pass_level_showoff":["share","level_showoff_share_click","level_showoff_share_click_success"],
            "buy_item": ["stage_start", null, "share_getcoins_send_success"],
            "level_bonus": ["level_bonus",  null, "share_success"],
            "pvp_new": ["PVP", null, "Invite_success"],
            "plusmore": ["plusFiveMoves", "click_share_btn", "click_share_btn_success"],
            "plusfive": ["plusFiveMoves", "click_share_btn", "click_share_btn_success"]
        }
    
        let orgShareClick = DCAssist.dc4ShareClick;
        DCAssist.dc4ShareClick = function (mainScene, textId, extractmap) {
            orgShareClick(mainScene, textId, extractmap);
            let ary = _oldShareSuccessMap[mainScene];
            if (ary && ary[0] && ary[1]) {
                DCAssist.userTrack(ary[0], ary[1], extractmap? Object.assign({"textid": textId}, extractmap): {"textid": textId});
            }
        }
    
        let orgShareSent = DCAssist.dc4ShareSent;
        DCAssist.dc4ShareSent = function (mainScene, textId, extractmap) {
            orgShareSent(mainScene, textId, extractmap);
            let ary = _oldShareSuccessMap[mainScene];
            if (ary && ary[0] && ary[2]) {
                DCAssist.dc4ClickShare(ary[0], ary[2], extractmap? Object.assign({"textid": textId}, extractmap): {"textid": textId});
            }
        }
    })();
}

/**
 * 正在处理中的分享
 */
let _stashShare = null;

/**
 * 缓存当前的分享参数
 */
function stashShare(mainScene, textId, timeJudge, otherData) {
    _stashShare = {
        textId,
        mainScene,
        timeJudge: timeJudge,
        sentTime: Localhost.time(),
        otherData: otherData
    }
}

/**
 * 清理当前缓存的分享参数
 */
function popStashShare() {
    let share = _stashShare;
    _stashShare = null;
    return share;
}

/**
 * 处理平台返回分享成功行为
 */
function onSnsShareSuccess() {
    let stashShare = popStashShare();
    if (!stashShare)
        return true;    // 没有缓存按分享成功处理
    
    let shareLimit = getShareTime(stashShare.mainScene) || 0;
    if (shareLimit <= 0 || Localhost.time() - stashShare.sentTime >= shareLimit) {
        DCAssist.dc4ShareSent(stashShare.mainScene, stashShare.textId, stashShare.otherData);
        return true;
    } else {
        // 需要使用分享时长重写的平台，时间未到认为分享失败
        return !stashShare.timeJudge;
    }
}

/**
 * 开始分享；调用这个函数以后不需要额外处理分享成功打点
 * @param {*} mainScene   分享主场景
 * @param {*} shareData    分享数据
 * @param {*} timeJudge   是否需要按照分享时长重写平台返回的分享成功结果
 * @param {*} onSuccess 分享成功回调
 * @param {*} onError 分享失败回调
 * @param {*} onCancel 分享取消回调
 * @param {*} otherData textId以外的分享成功需要打点的信息
 * 
 * 关于分享时间限制的说明：
 *   微信平台没有给出任何分享回调，目前是按照调起分享后监听onShow来判断用户分享行为结束；其它除了QQ以外的平台回调是onSuccess也不代表用户实际发出了分享小卡片，可能只是唤出分享界面并且直接返回了。
 *  进行裂变数据统计时，希望逼近实际点击次数/分享次数的数值，因此分享成功打点都采用了发起分享->分享回调onSuccess这一行为的时间长度近似认为玩家真正发出了分享；
 *   timeJudge传参false：游戏内逻辑通常只要平台分享接口回调onSuccess就认为分享成功，此时采信平台返回；
 *  timeJudge传参true：有部分分享行为结束时会直接发放奖励，对于这部分分享需要尽可能排除一唤起分享面板就返回的用户，因此在平台接口回调了onSuccess时，进一步根据以分享时长限制改写分享结果，超出时长的回调onSuccess，未超出的认为用户取消分享回调onCancel。
 *  【QQ以外平台的准则】
 *      1、超过分享时长限制一定回调onSuccess，并且进行了分享成功打点
 *      2、未超过分享时长限制一定不进行分享成功打点
 *      3、未超过分享时长限制时，timeJudge为true则回调onCancel，否则仍然回调onSuccess
 */
function runShare(mainScene, shareData, timeJudge, onSuccess, onError, onCancel, otherData) {
    stashShare(mainScene, shareData.textId, timeJudge, otherData);

    // 一个神秘的平台
    // 通过在微信中点击链接https://1106298530.urlshare.cn/?dw=1进入
    if (window.mqq && window.OPEN_DATA.qua.app == 'WX')
    {
        let panel = require("activity/QQLive/QQLiveSharePanel")
        panel.popup(true)
        panel.on(BasePanelEvent.Close, ()=> {
            if(onSnsShareSuccess()) {
                onSuccess && onSuccess(0, "", {});
            } else {
                onFail && onFail(1, "");
            }
        });

        return;
    }

    // let onSuccess_new = ()=>{
    //     DnSdkTool.getInstance().track("SHARE",{
    //         item:"APP_MESSAGE"
    //     })
    //     onSuccess && onSuccess()
    // }
    let callback = {
        onSuccess,
        onError,
        onCancel,
        vaildSuccess: onSnsShareSuccess
    }

    ShareProxy.getInstance().shareLink(shareData.textId, shareData.title, shareData.customContent || shareData.content || shareData.text, shareData.thumb, shareData.url, callback, shareData.shareScene || defaultShareScene, shareData.bg, true);
    shareData.customContent = null;
    shareData.url = null;
}

/**
 * 根据分享主场景获取分享组
 * 多个分享场景可能使用同一个分享组
 * 但是一个分享场景不可以使用多个分享组
 * @param {*} mainScene 
 */
function mainScene2ShareGroup(mainScene) {
    let shareGroupName = mainScene; // 通常mainScene 与 分享组名相同
    if (mainScene == "newchest_gacha" || mainScene == "newchest_reset") {
        shareGroupName = "new_chest"
    } else if(mainScene == "island_upgrade") {
        shareGroupName = "island_unlock"
    } else if(mainScene == "pass_level_showoff") {
        shareGroupName = "passlevel_showoff"
    }
    
    return shareGroupName;
}
/**
 * 根据分享组名获取分享行为预期最小用时，小于这个时间认为用户没有进行真正的分享行为
 * 单位：毫秒
 * @param {*} mainScene 
 */
function getShareTime(mainScene) {
    if (MetaManager.isUseRealShare())
        return 0;

    if (!_shareGroups || !_shareJudgeTimes) 
        return _defaultShareJudgeTime;
        
    let shareGroupName = mainScene2ShareGroup(mainScene);
    for(let i = 0; i < _shareGroups.length; i++) {
        if (_shareGroups[i] && _shareGroups[i].indexOf(shareGroupName) >= 0) {
            let value = _shareJudgeTimes[i];
            if (typeof value === "number" && !isNaN(value)) {
                return value;
            } else {
                break;
            }
        }
    }

    let defaultValue = _shareJudgeTimes[0];
    if (typeof defaultValue === "number" && !isNaN(defaultValue))
        return defaultValue;
    
    return _defaultShareJudgeTime
}

/**
 * 获取包装后的分享url参数部分
 * @param {*} mainScene 
 * @param {*} shareData 
 */
function getShareLinkStr(mainScene, shareData) {
    if (!shareData)
        shareData = {}
        
    shareData.mainScene = mainScene;
    shareData.srcapp = `feed_${mainScene}`;
    
    return GameProxy.getInstance().getShareLinkStr(shareData);
}

ShareUtil.clickTimeModeAskHelp = function(shareId, onSuccess, onFail, onCancel) { 
    let mainScene = "timeModeAskHelp";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));
    
    DCAssist.dc4ShareClick(mainScene, data.textId);

    let shareData = {
        timeModeShareId: shareId,
        nickname: UserManager.getInstance().profile.name
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink
    
    runShare(mainScene, data, false, onSuccess, onFail, onCancel);
}

ShareUtil.clickTimeModeShare = function(shareId, onSuccess, onFail, onCancel) {
    let mainScene = "timeModeShare";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId);

    let shareData = {
        type: "timeModeShare",
        shareId: shareId,
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data = {
        textId: data.textId,
        url: shareLink,
        title: data.content,
        bg: data.bg
    }
    runShare(mainScene, data, false, onSuccess,  onFail, onCancel);
} 

ShareUtil.clickTimeModeShowOff = function(onSuccess, onFail, onCancel) { 
    let mainScene = "timeModeShowOff";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));
    
    DCAssist.dc4ShareClick(mainScene, data.textId);
    
    let shareLink = getShareLinkStr(mainScene);
    data.url = shareLink

    runShare(mainScene, data, false, onSuccess, onFail, onCancel);

}

ShareUtil.clickCoinMatchAskHelp = function(onSuccess, onFail, onCancel) {
    let mainScene = "CoinMatchAskHelp";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId);
    
    let shareData = {
        type: "coinMatch",
        nickname: UserManager.getInstance().profile.name,
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink;
    runShare(mainScene, data, false, onSuccess, onFail, onCancel);
}

ShareUtil.clickCoinMatchFailedAskHelp = function(shareId, onSuccess, onFail, onCancel) {
    let mainScene = "CoinMatchFailedAskHelp";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId);

    let shareData = {
        shareId: shareId,
        shareType: GameLevelType.kCoinMatch.toString(),
        type: "coinMatch"
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink;
    runShare(mainScene, data, false, onSuccess, onFail, onCancel);
}

ShareUtil.clickCoinMatchShowOff = function(onSuccess, onFail, onCancel) {
    let mainScene = "CoinMatchShowOff";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId);

    let shareData = {
        type: "coinMatch",
        nickname: UserManager.getInstance().profile.name,
        isShowOff: 1
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink;
    runShare(mainScene, data, false, onSuccess, onFail, onCancel);
} 

ShareUtil.clickGoldMatchAskforhelp = function (shareId, onSuccess, onFail, onCancel) {
    let mainScene = "GoldMatchAskforhelp";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId);

    let shareData = {
        type: "goldMatchAddStepShare",
        shareId: shareId
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink;
    runShare(mainScene, data, false, onSuccess, onFail, onCancel);
}

ShareUtil.clickGoldMatchAskHelp = function (onSuccess, onFail, onCancel) {
    let mainScene = "GoldMatchAskHelp";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId);

    let shareData = {
        type: "goldMatch"
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink;
    runShare(mainScene, data, false, onSuccess, onFail, onCancel);
}

ShareUtil.clickGoldMatchShowOff = function (onSuccess, onFail, onCancel) {
    let mainScene = "GoldMatchShowOff";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId);

    let shareData = {
        type: "goldMatch"
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink;
    runShare(mainScene, data, false, onSuccess, onFail, onCancel);
}

/**
 * 岛屿解锁成功分享
 */
ShareUtil.shareIslandFull = function (onSuccess, onFail, onCancel) {
    let mainScene = "islands_fullstars";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));
    DCAssist.dc4ShareClick(mainScene, data.textId);

    let shareData = {
        type: "island_full"
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink;
    runShare(mainScene, data, true, onSuccess, onFail, onCancel);
}

ShareUtil.clickGroupRank = function (myrank, rankType, area, onSuccess, onFail, onCancel) {
    let mainScene = "group_rank";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId);

    let shareData = {
        type: "newrank_showoff",
        rank: myrank,
        rankType: rankType,
        area: area
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink;
    runShare(mainScene, data, false, onSuccess, onFail, onCancel);
}

ShareUtil.clickRankInvite = function (onSuccess, onFail, onCancel) {
    let mainScene = "rank_invite";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId);

    let shareData = {
        type: "newrank_share"
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink;
    runShare(mainScene, data, false, onSuccess, onFail, onCancel);
}

ShareUtil.clickPvpNew = function (roomid, onSuccess, onFail, onCancel) {
    let mainScene = "pvp_new";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId);

    let shareData = {
        roomid : roomid,
        isFriendPvp: true,
        type: "friend_pvp",
        userName: UserManager.getInstance().profile.name,
        userAvatar: UserManager.getInstance().profile.headUrl,
        inviteCode: UserManager.getInstance().inviteCode,
        time: Localhost.timeInSec()
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data = {
        textId: data.textId,
        url: shareLink,
        title: data.content,
        bg: data.bg
    }
    runShare(mainScene, data, false, onSuccess, onFail, onCancel);
}

ShareUtil.clickPvpNewShowOff = function (name, onSuccess, onFail, onCancel) {
    let mainScene = "pvp_new_showoff";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId);
    
    let shareLink = getShareLinkStr(mainScene);
    data.url = shareLink;
    data.customContent = data.content.replace("{name}", name);
    runShare(mainScene, data, false, onSuccess, onFail, onCancel);
}

/**
 * 互动分享邀请
 */
ShareUtil.clickInteractiveInvite = function (num, onSuccess, onFail, onCancel) {
    let mainScene = "interactive_invite";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    let otherDcData = { num }
    DCAssist.dc4ShareClick(mainScene, data.textId, otherDcData);
    
    let shareLink = getShareLinkStr(mainScene);
    data.url = shareLink; 
    runShare(mainScene, data, false, onSuccess, onFail, onCancel, otherDcData);
}

ShareUtil.clickMark = function (onSuccess, onFail, onCancel) {
    let mainScene = "mark";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId);
    
    let shareLink = getShareLinkStr(mainScene);
    data.url = shareLink; 
    runShare(mainScene, data, false, onSuccess, onFail, onCancel);
}

ShareUtil.clickTreasureBox = function (createTimeP, shareId, onSuccess, onFail, onCancel) {
    let mainScene = "treasure_box";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId);

    let shareData = {
        redbagTime: createTimeP,
        treasureBox: 1,
        shareId: shareId
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink; 
    runShare(mainScene, data, false, onSuccess, onFail, onCancel);
}

ShareUtil.clickNewChestReset = function (onSuccess, onFail, onCancel) {
    let mainScene = "newchest_reset";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));
    
    DCAssist.dc4ShareClick(mainScene, data.textId);
    
    let shareLink = getShareLinkStr(mainScene);
    data.url = shareLink; 
    runShare(mainScene, data, true, onSuccess, onFail, onCancel);
}

ShareUtil.clickNewChestReward = function (shareId, otherDcData, onSuccess, onFail, onCancel) {
    let mainScene = "newchest_gacha";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));
    
    DCAssist.dc4ShareClick(mainScene, data.textId, otherDcData);

    let shareData = {
        type: "newchest_big",
        bigRewardShareId: shareId
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink; 
    runShare(mainScene, data, true, onSuccess, onFail, onCancel, otherDcData);
}

ShareUtil.clickHappyCoin = function (shareId, onSuccess, onFail, onCancel) {
    let mainScene = "happycoin";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId);

    let shareData = {
        type: "happycoinNotEnough",
        shareId: shareId,
        uid: UserManager.getInstance().uid
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink; 
    runShare(mainScene, data, true, onSuccess, onFail, onCancel);
}

/**
 * 岛屿解锁加速分享
 */
ShareUtil.clickIslandUpgrade = function (shareId, onSuccess, onFail, onCancel) {
    let mainScene = "island_upgrade";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId);
    
    let shareData = {
        type: "island_unlock",
        shareId: shareId,
        subType: "upgrade"
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink;
    runShare(mainScene, data, true, onSuccess, onFail, onCancel);
}



/**
 * 岛屿解锁加速分享
 */
ShareUtil.clickIslandAddTime = function (onSuccess, onFail, onCancel) {
    let mainScene = "island_skip";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId);

    let shareData = {
        type: "island_unlock",
        subType: "islanspdup_share"
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink; 
    runShare(mainScene, data, true, onSuccess, onFail, onCancel);
}


/**
 * 岛屿解锁好友帮助分享
 */
ShareUtil.clickIslandFriendHelp = function (shareId, onSuccess, onFail, onCancel) {
    let mainScene = "island_unlock";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId);
    
    let shareData = {
        type: "island_unlock",
        subType: "islanspdup_share",
        shareId: shareId,
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink; 
    runShare(mainScene, data, true, onSuccess, onFail, onCancel);
}

ShareUtil.clickLevelBonus = function(otherDcData, onSuccess, onFail, onCancel)
{
    let mainScene = "level_bonus";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId, otherDcData);
    
    let shareData = {
        type: "level_bonus"
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink; 
    runShare(mainScene, data, true, onSuccess, onFail, onCancel, otherDcData);
}


/**
 * 关末礼包邀请
 */
ShareUtil.clickLevelInvitePack = function (shareId, onSuccess, onFail, onCancel) {
    let mainScene = "invite_pack";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId);
    
    let shareData = {
        type: "giftbag_invite",
        shareId: shareId
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink; 
    runShare(mainScene, data, true, onSuccess, onFail, onCancel);
}

ShareUtil.clickStrategyShare = function (strategyId, levelId, onSuccess, onFail, onCancel) {
    let mainScene = "level_tip";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    let otherDcData = {num: levelId}
    DCAssist.dc4ShareClick(mainScene, data.textId, otherDcData);
    
    let shareData = {
        type: "strategy",
        time: Localhost.time()
    }
    if (strategyId) {
        shareData.strategyId = strategyId;
        shareData.levelId = levelId;
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink;
    data.customContent = data.content.replace("{level}", levelId);
    
    runShare(mainScene, data, true, onSuccess, onFail, onCancel, otherDcData);
}


/**
 * 关末急速加步数分享
 */
//plusFiveMoves isquick = true
ShareUtil.clickPlusMore = function (shareId, otherDcData, onSuccess, onFail, onCancel, ) {
    let mainScene = "plusmore";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId, otherDcData);
    
    let shareData = {
        add5ShareId: shareId,
        isQuick: "1"
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink; 
    runShare(mainScene, data, true, onSuccess, onFail, onCancel, otherDcData);
}


/**
 * 关末急速加步数分享
 */
ShareUtil.clickPlusFive = function (shareId, otherDcData, onSuccess, onFail, onCancel) {
    let mainScene = "plusfive";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId, otherDcData);
    
    let shareData = {
        add5ShareId: shareId,
        isQuick: "0"
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink; 
    runShare(mainScene, data, true, onSuccess, onFail, onCancel, otherDcData);
}

/**
 * 求超越分享
 * @param {*} levelId 
 * @param {*} score 
 * @param {*} issuerAvatar 
 * @param {*} onSuccess 
 * @param {*} onFail 
 * @param {*} onCancel 
 */
function challengeShare(isInviter, levelId, score, issuerAvatar, onSuccess, onFail, onCancel, otherDcData){
    let mainScene = "passlevel_challenge";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId, otherDcData);

    let shareData = {
        challengeLevelId: levelId,
        formerScore: score,
        issuerAvatar: UserManager.getInstance().profile.headUrl,
        timeStamp: Localhost.timeInSec()
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink; 
    data.customContent = data.content.replace(/\{level\}/, levelId).replace(/\{rank\}/, score);

    if (isInviter || (window.mini && !mini.canShareUseRemoteImageUrl())) {
        runShare(mainScene, data, true, onSuccess, onFail, onCancel, otherDcData);
    } else {
        let bgImg = "share/challenge/challenge_win.jpg"
        let drawData = {
            avatar: UserManager.getInstance().profile.headUrl,
            avatarPos: cc.p(54, 116),
            avatarFail: issuerAvatar,
            avatarFailRaidus: 41.5,
            avatarFailPos: cc.p(323.5,195),
        }
        
        function onDrawComplete(bgPath) {
            if (bgPath) {
                // let shareData = {
                //     url: shareLink,
                //     textId: "challenge_02",
                //     text: `无敌是多么寂寞，敢来挑战我么？`,
                // }
                data = Object.assign({}, data);
                data.bg = bgPath;
                runShare(mainScene, data, true, onSuccess, onFail, onCancel, otherDcData);
            }else {
                runShare(mainScene, data, true, onSuccess, onFail, onCancel, otherDcData);
            }
        }
        SnsProxy.getInstance().drawDataToImg(bgImg, drawData, onDrawComplete);
    }
}
/**
 * 点击求超越分线进入的玩家战斗胜利分享
 * @param {*} levelId 
 * @param {*} score 
 * @param {*} issuerAvatar 
 * @param {*} onSuccess 
 * @param {*} onFail 
 * @param {*} onCancel 
 */
ShareUtil.clickChallengeBeat = function (levelId, score, issuerAvatar, onSuccess, onFail, onCancel) {
    challengeShare(false, levelId, score, issuerAvatar, onSuccess, onFail, onCancel);
}

/**
 * 战斗胜利分享给他人求超越
 * @param {*} levelId 
 * @param {*} score 
 * @param {*} onSuccess 
 * @param {*} onFail 
 * @param {*} onCancel 
 */
ShareUtil.clickChallengeShare = function (levelId, score, onSuccess, onFail, onCancel, otherDcData) {
    challengeShare(true, levelId, score, null, onSuccess, onFail, onCancel, otherDcData);
}

ShareUtil.clickPassLevelShowOff = function (otherDcData, onSuccess, onFail, onCancel) {
    let mainScene = "pass_level_showoff";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId, otherDcData);

    let shareLink = getShareLinkStr(mainScene);
    data.url = shareLink; 
    runShare(mainScene, data, false, onSuccess, onFail, onCancel, otherDcData);
}

ShareUtil.clickCoinNotEnough = function (shareId, onSuccess, onFail, onCancel) {
    let mainScene = "buy_item";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));

    DCAssist.dc4ShareClick(mainScene, data.textId);

    let shareData = {
        type: "coinNotEnough",
        shareId: shareId
    }

    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink; 
    runShare(mainScene, data, true, onSuccess, onFail, onCancel);
}

/**
 * 海滨之星求助翻倍卡
 */
ShareUtil.shareSeasideStarDoubleCard = function (shareId,onSuccess, onFail, onCancel) {
    let mainScene = "coast_star_double_collection";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));
    DCAssist.dc4ShareClick(mainScene, data.textId);

    let shareData = {
        type: "seasideStarShare",
        shareId : shareId,
        inviteCode: UserManager.getInstance().uid
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    cc.log("[Seaside]", "ShareUtil shareSeasideStarDoubleCard shareLink",shareLink);
    data.url = shareLink;
    cc.log("[Seaside]", "ShareUtil shareSeasideStarDoubleCard data",data);
    runShare(mainScene, data, true, onSuccess, onFail, onCancel);
}

/**
 *  限时闯关 闯关次数
 */
 ShareUtil.shareLightningRush = function (shareId,onSuccess, onFail, onCancel) {
    let mainScene = "lightening_rush";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));
    DCAssist.dc4ShareClick(mainScene, data.textId);
    
    
    let shareData = {
        type: "lightningRush",
        shareId : shareId,
        inviteCode: UserManager.getInstance().uid
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    cc.log("lightningRush", "ShareUtil shareLightningRush shareLink",shareLink);
    data.url = shareLink;
    cc.log("lightningRush", "ShareUtil shareLightningRush data",data);
    runShare(mainScene, data, true, onSuccess, onFail, onCancel);
}
// 
ShareUtil.newUserTask = function(onSuccess, onFail, onCancel)
{
    let mainScene = "newtask_share";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));
    DCAssist.dc4ShareClick(mainScene, data.textId);
    
    let shareData = {
        type: "newtask_share"
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    data.url = shareLink; 
    runShare(mainScene, data, true, onSuccess, onFail, onCancel);
}

ShareUtil.mysteryExhibitionHall = function(onSuccess, onFail, onCancel)
{
    let mainScene = "trophy_sharing"
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene))
    DCAssist.dc4ShareClick(mainScene, data.textId)
    
    let shareData = {
        type: "trophy_sharing"
    }
    let shareLink = getShareLinkStr(mainScene, shareData)
    data.url = shareLink
    runShare(mainScene, data, true, onSuccess, onFail, onCancel)
}
// 排名结算分享
ShareUtil.mysteryRankSettlement = function(rank, onSuccess, onFail, onCancel)
{
    let mainScene = "ranking_sharing"
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene))
    DCAssist.dc4ShareClick(mainScene, data.textId)
    
    let shareData = {
        type: "ranking_sharing"
    }
    let shareLink = getShareLinkStr(mainScene, shareData)
    data.url = shareLink
    data.customContent = data.content.replace("{rank}", rank);
    if (rank ==0){
        data.customContent = "我在神秘岛挑战中获得了全国排名专属奖牌，你也快来试试吧！"
    }
    
    runShare(mainScene, data, true, onSuccess, onFail, onCancel)
}
ShareUtil.qualifyDailyReward = function(onSuccess, onFail, onCancel)
{
    let mainScene = "main_race_reward"
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene))
    DCAssist.dc4ShareClick(mainScene, data.textId)
    let shareData = {
        type: "main_race_reward"
    }
    let shareLink = getShareLinkStr(mainScene, shareData)
    data.url = shareLink
    runShare(mainScene, data, true, onSuccess, onFail, onCancel)
}

ShareUtil.shareQualifyTeamUp = function (shareId,onSuccess, onFail, onCancel) {
    let mainScene = "main_race_invite";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));
    DCAssist.dc4ShareClick(mainScene, data.textId);

    let shareData = {
        type: "qualify",
        shareId : shareId,
        inviteCode: UserManager.getInstance().uid
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    cc.log("Qualify", "ShareUtil shareQualifyTeamUp shareLink",shareLink);
    data.url = shareLink;
    cc.log("Qualify", "ShareUtil shareQualifyTeamUp data",data);
    runShare(mainScene, data, true, onSuccess, onFail, onCancel);
}

ShareUtil.shareStarDreamTeamUp = function (shareId,onSuccess, onFail, onCancel) {
    let mainScene = "star_factory";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));
    DCAssist.dc4ShareClick(mainScene, data.textId);

    let shareData = {
        type: "stardream",
        shareId : shareId,
        inviteCode: UserManager.getInstance().uid
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    cc.log("stardream", "ShareUtil shareStarDreamTeamUp shareLink",shareLink);
    data.url = shareLink;
    cc.log("stardream", "ShareUtil shareStarDreamTeamUp data",data);
    runShare(mainScene, data, true, onSuccess, onFail, onCancel);
}
// 分享贴贴
ShareUtil.shareStickerCollect = function(onSuccess, onFail, onCancel)
{
    let mainScene = "sticker_race"
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene))
    DCAssist.dc4ShareClick(mainScene, data.textId)
    
    let shareData = {
        type: "sticker_race"
    }
    let shareLink = getShareLinkStr(mainScene, shareData)
    data.url = shareLink
    runShare(mainScene, data, true, onSuccess, onFail, onCancel)
}

ShareUtil.shareFishing = function(shareId, fishId, onSuccess, onFail, onCancel)
{
    let mainScene = "fishing_master"
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));
    let list = TextsManager.getInstance().getTextsListByType(mainScene);
    let curData = null;
    let tempId = fishId < 10 ? "0" + fishId : fishId;
    tempId = "fishing_master_07_29_" + tempId;
    for (let i = 0; i < list.length; i++) {
        let temp = list[i];
        if (temp && temp.textId == tempId) {
            curData = temp;
            break;
        }
    }
    if (curData) {
        data = JSON.parse(JSON.stringify(data));
        for (let key in curData) {
            data[key] = curData[key];
        }
    }
    //
    DCAssist.dc4ShareClick(mainScene, data.textId)
    
    let shareData = {
        type: "fishing",
        inviteCode: UserManager.getInstance().uid,
        shareId,
        fishId,
    }
    let shareLink = getShareLinkStr(mainScene, shareData)
    data.url = shareLink
    runShare(mainScene, data, true, onSuccess, onFail, onCancel)
}

ShareUtil.shareMedalRank = function(levelId, rank, onSuccess, onFail, onCancel)
{
    let mainScene = "medal_rank"
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene))
    DCAssist.dc4ShareClick(mainScene, data.textId)
    
    let shareData = {
        type: "medal_rank"
    }
    let shareLink = getShareLinkStr(mainScene, shareData)
    data.url = shareLink;
    data.customContent = data.content.replace(/\{level\}/, levelId).replace(/\{rank\}/, rank);
    runShare(mainScene, data, true, onSuccess, onFail, onCancel)
}
// 宠物邀请组队
ShareUtil.sharePetStoryTeamUp = function (shareId,onSuccess, onFail, onCancel) {
    let mainScene = "pet_story_invite";
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));
    DCAssist.dc4ShareClick(mainScene, data.textId);

    let shareData = {
        type: "petstory",
        shareId : shareId,
        inviteCode: UserManager.getInstance().uid
    }
    let shareLink = getShareLinkStr(mainScene, shareData);
    cc.log("[PetStory]", "ShareUtil sharePetStoryTeamUp shareLink",shareLink);
    data.url = shareLink;
    cc.log("[PetStory]", "ShareUtil sharePetStoryTeamUp data",data);
    runShare(mainScene, data, true, onSuccess, onFail, onCancel);
}

ShareUtil.shareWeekRank = function(rankName, rankNo, onSuccess, onFail, onCancel)
{
    let mainScene = "weekly_rank"
    let data = TextsManager.getInstance().getRandomTexts(mainScene2ShareGroup(mainScene));
    let list = TextsManager.getInstance().getTextsListByType(mainScene);
    let curData = null;
    const tempId = rankNo ? "weekly_rank1" : "weekly_rank2";
    for (let i = 0; i < list.length; i++) {
        let temp = list[i];
        if (temp && temp.textId == tempId) {
            curData = temp;
            break;
        }
    }
    if (curData) {
        data = JSON.parse(JSON.stringify(data));
        for (let key in curData) {
            data[key] = curData[key];
        }
    }
    DCAssist.dc4ShareClick(mainScene, data.textId)
    
    let shareData = {
        type: "weekly_rank"
    }

    let shareLink = getShareLinkStr(mainScene, shareData)
    if(rankNo) {
        data.customContent = data.content.replace(/\{rankType\}/, rankName).replace(/\{rank\}/, rankNo);
    }
    data.url = shareLink;
    runShare(mainScene, data, true, onSuccess, onFail, onCancel)
}

function init() {  
    CfgManager.load("game").then( (dataMap)=>{
        let config = dataMap.get("game");
        CfgManager.release("game");

        _shareJudgeTimes = null;
        _shareGroups = null;

        if (!config)
            return;

        if (config.share_judge_time && config.share_judge_time.length) {
            _shareJudgeTimes = config.share_judge_time
        }

        if (_shareJudgeTimes) {
            _shareGroups = [];
            for(let i = 0; i < _shareJudgeTimes.length; i++) {
                _shareGroups[i] = config[`share_judge_group${i+1}`];
            }
        }
    });
}
init();

module.exports = ShareUtil;